import { defineComponent as d, openBlock as t, createElementBlock as o, mergeProps as A, unref as e, renderSlot as p, createElementVNode as n, createCommentVNode as i } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const h = { key: 0 }, g = { key: 1 }, f = { key: 2 }, v = { key: 3 }, M = { key: 4 }, k = { key: 5 }, V = {
  name: "ScalarIconChatTeardropDots"
}, _ = /* @__PURE__ */ d({
  ...V,
  props: {
    label: {},
    weight: {}
  },
  setup(m) {
    const r = m, { bind: s, weight: l } = u(r);
    return (Z, a) => (t(), o("svg", A({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      p(Z.$slots, "default"),
      e(l) === "bold" ? (t(), o("g", h, a[0] || (a[0] = [
        n("path", { d: "M132,20A104.11,104.11,0,0,0,28,124v84a20,20,0,0,0,20,20h84a104,104,0,0,0,0-208Zm0,184H52V124a80,80,0,1,1,80,80Zm-8-76a16,16,0,1,1-16-16A16,16,0,0,1,124,128Zm48,0a16,16,0,1,1-16-16A16,16,0,0,1,172,128Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (t(), o("g", g, a[1] || (a[1] = [
        n("path", {
          d: "M224,124h0a92,92,0,0,1-92,92H48a8,8,0,0,1-8-8V124a92,92,0,0,1,92-92h0A92,92,0,0,1,224,124Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M132,24A100.11,100.11,0,0,0,32,124v84a16,16,0,0,0,16,16h84a100,100,0,0,0,0-200Zm0,184H48V124a84,84,0,1,1,84,84Zm12-80a12,12,0,1,1-12-12A12,12,0,0,1,144,128Zm-44,0a12,12,0,1,1-12-12A12,12,0,0,1,100,128Zm88,0a12,12,0,1,1-12-12A12,12,0,0,1,188,128Z" }, null, -1)
      ]))) : e(l) === "fill" ? (t(), o("g", f, a[2] || (a[2] = [
        n("path", { d: "M132,24A100.11,100.11,0,0,0,32,124v84a16,16,0,0,0,16,16h84a100,100,0,0,0,0-200ZM88,140a12,12,0,1,1,12-12A12,12,0,0,1,88,140Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,132,140Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,176,140Z" }, null, -1)
      ]))) : e(l) === "light" ? (t(), o("g", v, a[3] || (a[3] = [
        n("path", { d: "M142,128a10,10,0,1,1-10-10A10,10,0,0,1,142,128ZM88,118a10,10,0,1,0,10,10A10,10,0,0,0,88,118Zm88,0a10,10,0,1,0,10,10A10,10,0,0,0,176,118Zm54,6a98.11,98.11,0,0,1-98,98H48a14,14,0,0,1-14-14V124a98,98,0,0,1,196,0Zm-12,0a86,86,0,0,0-172,0v84a2,2,0,0,0,2,2h84A86.1,86.1,0,0,0,218,124Z" }, null, -1)
      ]))) : e(l) === "regular" ? (t(), o("g", M, a[4] || (a[4] = [
        n("path", { d: "M132,24A100.11,100.11,0,0,0,32,124v84a16,16,0,0,0,16,16h84a100,100,0,0,0,0-200Zm0,184H48V124a84,84,0,1,1,84,84Zm12-80a12,12,0,1,1-12-12A12,12,0,0,1,144,128Zm-44,0a12,12,0,1,1-12-12A12,12,0,0,1,100,128Zm88,0a12,12,0,1,1-12-12A12,12,0,0,1,188,128Z" }, null, -1)
      ]))) : e(l) === "thin" ? (t(), o("g", k, a[5] || (a[5] = [
        n("path", { d: "M140,128a8,8,0,1,1-8-8A8,8,0,0,1,140,128Zm-52-8a8,8,0,1,0,8,8A8,8,0,0,0,88,120Zm88,0a8,8,0,1,0,8,8A8,8,0,0,0,176,120Zm52,4a96.11,96.11,0,0,1-96,96H48a12,12,0,0,1-12-12V124a96,96,0,0,1,192,0Zm-8,0a88,88,0,0,0-176,0v84a4,4,0,0,0,4,4h84A88.1,88.1,0,0,0,220,124Z" }, null, -1)
      ]))) : i("", !0)
    ], 16));
  }
});
export {
  _ as default
};
